import { alpha, Theme } from '@mui/material/styles';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";

const styles = (theme: Theme) => createStyles({
    container: {
        position: "relative",
        lineHeight: "inherit",
        marginBottom: 2,
        borderStyle: "solid",
        borderWidth: 1
    },
    label: {
        position: "absolute",
        top: 0,
        paddingLeft: theme.spacing(1)
    },

    bar: {
        backgroundColor: theme.palette.grey[300],
        height: "100%",
    },

    barWin: {
        backgroundColor: alpha(theme.palette.grey[900], 0.7),
        height: "100%",
    },


    info: {
        borderColor: theme.genie.palette.info.dark,
        color: theme.genie.palette.info.contrastText,
        backgroundColor: alpha(theme.genie.palette.info.main, 0.3),
        "& $bar": {
            backgroundColor: theme.genie.palette.info.main,
        },
        "& $barWin": {
            backgroundColor: alpha(theme.genie.palette.info.main, 0.7),
        },
    },
    success: {
        borderColor: theme.genie.palette.success.dark,
        color: theme.genie.palette.success.contrastText,
        backgroundColor: alpha(theme.genie.palette.success.main, 0.3),
        "& $bar": {
            backgroundColor: theme.genie.palette.success.main
        },
        "& $barWin": {
            backgroundColor: alpha(theme.genie.palette.success.main, 0.7),
        },
    },
    warning: {
        borderColor: theme.genie.palette.warning.dark,
        color: theme.genie.palette.warning.contrastText,
        backgroundColor: alpha(theme.genie.palette.warning.main, 0.3),
        "& $bar": {
            backgroundColor: theme.genie.palette.warning.main
        },
        "& $barWin": {
            backgroundColor: alpha(theme.genie.palette.warning.main, 0.7),
        },
    },
    error: {
        borderColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
        backgroundColor: alpha(theme.palette.error.main, 0.3),
        "& $bar": {
            backgroundColor: theme.palette.error.main,
        },
        "& $barWin": {
            backgroundColor: alpha(theme.palette.error.main, 0.7),
        },
    },
    primary: {
        borderColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        backgroundColor: alpha(theme.palette.primary.main, 0.3),
        "& $bar": {
            backgroundColor: theme.palette.primary.main,
        },
        "& $barWin": {
            backgroundColor: alpha(theme.palette.primary.main, 0.7),
        },
    },
    secondary: {
        borderColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText,
        backgroundColor: alpha(theme.palette.secondary.main, 0.3),
        "& $bar": {
            backgroundColor: theme.palette.secondary.main,
        },
        "& $barWin": {
            backgroundColor: alpha(theme.palette.secondary.main, 0.7),
        }
    }
});

export interface IProps {
    maxWidth: number;
    percent: number;
    text: React.ReactNode;
    highlight?: boolean;
    color: "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

type Props = IProps & WithStyles<typeof styles>;

const ProgressBar: React.FC<Props> = (props) => {

    const { highlight, percent, maxWidth, text, color, classes } = props;

    var cls = classNames({
        [classes.container]: true,
        [classes[color]]: true,
    });

    var w = Math.round(percent / 100.0 * maxWidth);

    return (
        <div className={cls} style={{ width: maxWidth }}>
            <div className={classes.label}>
                {
                    highlight
                        ? <b>{text}</b>
                        : <span>{text}</span>
                }
            </div>
            <div className={highlight ? classes.barWin : classes.bar} style={{ width: w }}>
                <span>&nbsp;</span>
            </div>
        </div>
    );
}

export default withStyles(styles)(ProgressBar);
